import { Notification } from '@notify/models/notification';

export const NotificationFormatter = {
  formatItem: function(item) {
    const transform = new Notification(item);

    return {
      ...transform,
      theme: transform.getTheme(),
      text: transform.getText(),
      i18n_props: transform.getI18nProps()
    };
  },

  formatItems: function(items = []) {
    return items.map(item => NotificationFormatter.formatItem(item));
  }
};
